// extracted by mini-css-extract-plugin
export var legendIndicator = "_c2-1";
export var legendRight = "_c2-0";